const SettingsPopup = ({ settingList, isVideoFromLibrary }) => {
  const filterDeleteOption = (settingList) =>
    settingList?.filter(
      (ele) => ele.isVideoFromHighlight || ele?.name !== "Delete"
    );

  return (
    <div className="mg-top-10 action-menu-container mg-bottom-10">
      {(isVideoFromLibrary
        ? settingList
        : filterDeleteOption(settingList)
      )?.map((item, index) => (
        <div
          className={`manage-section-dropdown-item cp`}
          key={index}
          onClick={() => item?.handleSubmit()}
        >
          {item?.icon}
          <div className="manage-section-dropdown-item-link">
            <p className="manage-small-popup-menuu1-p">{item?.name}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SettingsPopup;
